import { MasterDialog } from "#common/Dialog/Dialog"
import { COLOR_PRIMARY } from "#constants/Styles"
import { useApiSend } from "#hooks/useApiSend"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Skeleton from "@mui/material/Skeleton"
import Step from "@mui/material/Step"
import StepContent from "@mui/material/StepContent"
import StepLabel from "@mui/material/StepLabel"
import Stepper from "@mui/material/Stepper"
import Typography from "@mui/material/Typography"
import { useMemo, useState } from "react"
import { toast } from "react-toastify"
import { fondoFijoPost } from "../services/Api"
import { UseFondoFijoV2 } from "../useFondoFijo"
import SelectColaborador from "./SelectColaborador"
import SelectMovimiento from "./SelectMovimiento"

const NEW = "Nuevo",
	INC = "Incremento",
	DEC = "Decremento",
	DEL = "Cancelación"

export default function FondoFijoFormulario({
	open,
	setOpen,
	colaborador = null,
	actualizar = () => {},
}) {
	const [activeStep, setActiveStep] = useState(0)
	const [data, setData] = useState({})
	const [archivo, setArchivo] = useState(null)
	const [disabled, setDisabled] = useState(false)

	const params = useMemo(() => {
		if (colaborador) return { colaborador }
		else return { colaboradores: true }
	}, [colaborador])

	const { fondoFijo: colaboradores, loading } = UseFondoFijoV2({
		activar: !!open,
		params,
	})
	const handleClose = () => {
		setData({})
		setOpen(false)
		setActiveStep(0)
	}
	const success = () => {
		actualizar()
		handleClose()
	}
	const { fetch } = useApiSend(fondoFijoPost, {
		success,
		end: () => setDisabled(false),
	})

	const getArchivo = (archivo) => {
		setArchivo(archivo)
	}

	const getDatos = (dato) => {
		setData({ ...data, ...dato })
	}

	const steps = [
		{
			label: "Seleccionar Colaborador",
			description: (
				<SelectColaborador
					colaboradores={colaboradores}
					colaborador_select={colaborador}
					onChang={(datos) => setData({ ...data, ...datos })}
				/>
			),
			next: !data.colaborador || !data.type,
		},
		{
			label: "Proceso",
			description: (
				<SelectMovimiento
					data={data}
					onChang={getDatos}
					onChangDoc={getArchivo}
				/>
			),
		},
	]

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1)
	}

	const handleSend = async () => {
		const { type, cantidad, quantity } = data
		console.log("data", type, cantidad, quantity)
		if ([NEW, INC, DEC].includes(type) && !cantidad) {
			toast.error(`Se requiere la cantidad`)
			return null
		} else if (type === INC && parseFloat(cantidad) < quantity) {
			toast.error(`el fondo debe ser mayor a ${quantity}`)
			return null
		} else if (type === DEC && parseFloat(cantidad) > quantity) {
			toast.error(`el fondo debe ser menor a ${quantity}`)
			return null
		} else if (type === NEW && parseFloat(cantidad) <= 0) {
			toast.error(`el fondo debe ser mayor a 0`)
			return null
		} else if ([NEW, INC].includes(type) && !archivo) {
			toast.error("Se requiere el archivo")
			return null
		}

		if (data.type === DEL) data.quantity = 0

		let sendData = { ...data }
		if (sendData.cantidad) {
			sendData.quantity = data.cantidad
			delete sendData.cantidad
		}

		let formData = new FormData()

		for (let dato in sendData) {
			formData.append(dato, sendData[dato])
		}

		if (archivo) formData.append("doc", archivo)
		setDisabled(true)
		fetch(formData)
	}

	if (loading)
		return (
			<Dialog open={open} setOpen={setOpen} onClose={handleClose}>
				<Box sx={{ maxWidth: "100%" }}>
					<Skeleton variant="rectangular" width={"100%"} height={80} />
				</Box>
			</Dialog>
		)
	return (
		<Dialog open={open} setOpen={setOpen} onClose={handleClose}>
			<Box sx={{ maxWidth: "100%" }}>
				<Stepper activeStep={activeStep} orientation="vertical">
					{steps.map((step, index) => (
						<Step key={step.label}>
							<StepLabel
								optional={
									index === 2 ? (
										<Typography variant="caption">
											Seleccionar Colaborador
										</Typography>
									) : null
								}
							>
								{step.label}
							</StepLabel>
							<StepContent>
								{step.description}
								<Box sx={{ mb: 2 }}>
									<div>
										<Button
											// disabled={index === 0}
											onClick={handleClose}
											variant="contained"
											sx={{
												backgroundColor: COLOR_PRIMARY,
												mt: 1,
												mr: 1,
											}}
										>
											Cancelar
										</Button>
										<Button
											disabled={disabled || step.next}
											variant="contained"
											onClick={
												index === steps.length - 1
													? handleSend
													: handleNext
											}
											sx={{
												backgroundColor: COLOR_PRIMARY,
												mt: 1,
												mr: 1,
											}}
										>
											{index === steps.length - 1
												? "Enviar"
												: "Continuar"}
										</Button>
									</div>
								</Box>
							</StepContent>
						</Step>
					))}
				</Stepper>
			</Box>
		</Dialog>
	)
}

const Dialog = (props) => {
	return (
		<MasterDialog
			title={"Solicitud Fondo Fijo"}
			open={props.open}
			setOpen={props.setOpen}
			onClose={props.onClose}
			maxWidth={"sm"}
		>
			{props.children}
		</MasterDialog>
	)
}
